import { Spinner } from '../components';

export function FullScreenLoader() {
  return (
    <div className="flex h-full items-center justify-center text-brand">
      <Spinner size={36} />
    </div>
  );
}
